import React from 'react'
import PropTypes from 'prop-types'
import { FormCard } from '../../../components'
import { Button, Icon } from '@salesforce/design-system-react'

const SecondRelationshipContactForm = ({ formData, onEditButtonClicked }) => {
  return (
    <FormCard
      header='Second Relationship Contact'
      readOnly={true}
      icon={<Icon category='standard' name='account' />}
      form={formData}
      onInputChanged={() => null}
      headerActions={<Button label='Edit' onClick={onEditButtonClicked} />}
    />
  )
}

SecondRelationshipContactForm.propTypes = {
  formData: PropTypes.object,
  onEditButtonClicked: PropTypes.func
}

export default SecondRelationshipContactForm
